/* keyedalike.com — header search (sections/header.liquid): the ≤1100 toggle, and Escape for open suggestions.
   - Above 1100 the field sits in the header row and the toggle is hidden (ka-header.css); nothing to do.
   - At ≤1100 the toggle, a plain link to /search without JS, acts as a button: click, Enter or Space opens the
     same form as a row under the logo (data-search-open="true" on the header, aria-expanded="true" on the
     toggle) and puts the cursor in the field; a second click, or Escape in the row, closes it and returns focus
     to the toggle. Widening past 1100 resets it. The search template renders the row already open (the page
     has no field of its own); the toggle's initial state is read from the header, not assumed closed.
   - Escape in any field whose suggestions are open closes them and keeps the cursor and the text (Dawn's
     predictive-search.js has no Escape; close() is its own method). In the ≤1100 row the next Escape closes
     the row.
   - The arrow keys move aria-selected through the suggestions (Dawn's script) but never scroll; the panel can be
     taller than the screen, so the selected option is scrolled into view here.
   Dawn's search scripts are untouched. */
(() => {
  if (window.kaHeaderSearch) return;
  window.kaHeaderSearch = true;

  const narrow = window.matchMedia('(max-width: 1100px)');

  const init = (root) => {
    root.querySelectorAll('[data-ka-search-toggle]').forEach((toggle) => {
      if (toggle.dataset.kaReady) return;
      const head = toggle.closest('[data-ka-head]');
      const form = document.getElementById(toggle.getAttribute('aria-controls'));
      const input = form ? form.querySelector('input[type="search"]') : null;
      if (!head || !input) return;
      toggle.dataset.kaReady = 'true';
      const isOpen = () => head.dataset.searchOpen === 'true';
      const setOpen = (open) => {
        head.dataset.searchOpen = String(open);
        toggle.setAttribute('aria-expanded', String(open));
      };
      toggle.setAttribute('role', 'button');
      toggle.setAttribute('aria-expanded', String(isOpen())); // the search template renders the row open

      toggle.addEventListener('click', (event) => {
        if (!narrow.matches) return;
        event.preventDefault();
        if (isOpen()) {
          setOpen(false);
          toggle.focus();
        } else {
          setOpen(true);
          input.focus();
        }
      });
      // a link answers Enter only; as a button it answers Space too
      toggle.addEventListener('keydown', (event) => {
        if (event.key !== ' ') return;
        event.preventDefault();
        toggle.click();
      });
      // Escape in the open row closes it, once its suggestions are closed (the document listener below goes second)
      form.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape' || !isOpen() || !narrow.matches) return;
        const suggestions = form.closest('predictive-search');
        if (suggestions && suggestions.hasAttribute('open')) return;
        event.preventDefault();
        setOpen(false);
        toggle.focus();
      });
      narrow.addEventListener('change', () => {
        if (!narrow.matches && isOpen()) setOpen(false);
      });
    });
  };

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape' || !(event.target instanceof Element)) return;
    const suggestions = event.target.closest('predictive-search');
    if (!suggestions || !suggestions.hasAttribute('open') || typeof suggestions.close !== 'function') return;
    event.preventDefault(); // a search input would also clear itself on Escape
    suggestions.close();
  });

  const follow = new MutationObserver((records) => {
    records.forEach(({ target }) => {
      if (target.getAttribute('aria-selected') === 'true') target.scrollIntoView({ block: 'nearest' });
    });
  });
  const watch = (root) => {
    root.querySelectorAll('[data-predictive-search]').forEach((panel) => {
      follow.observe(panel, { attributes: true, attributeFilter: ['aria-selected'], subtree: true });
    });
  };

  init(document);
  watch(document);
  document.addEventListener('shopify:section:load', (event) => { // the theme editor re-renders sections
    init(event.target);
    watch(event.target);
  });
})();
